<template>
  <div>
    <div class="card">
      <div class="card-header">
        <h4 class="card-header-title">{{ $t('Partners deposits') }}</h4>
        <router-link
          :to="'/partnersDeposits/create?partner_id=' + $route.params.id"
          class="btn btn-sm btn-primary"
        >
          <i class="fas fa-plus"></i> {{ $t('Addition') }}
        </router-link>
      </div>
      <indexTable
        :searchText="$t('Search for an operation')"
        :emptyTableText="$t('No deposits')"
        :filter="{ partner_id: $route.params.id }"
        :withoutCard="true"
        :emptyTableSubText="$t('Try adding some items to the table and try again')"
        :cloumns="[
          {
            column: 'code',
            title: $t('Process'),
            type: 'mainLink',
            sort: true
          },
          {
            column: 'partner_id',
            title: $t('Partner name'),
            type: 'link',
            to: 'partner',
            sort: true,
            link: true
          },
          {
            column: 'safe_id',
            title: $t('Treasury'),
            type: 'link',
            to: 'safe',
            sort: true,
            link: true
          },
          {
            column: 'date',
            title: $t('date'),
            type: 'text',
            sort: true
          },
          {
            column: 'description',
            title: $t('And that is about'),
            type: 'text',
            sort: true
          },
          {
            column: 'cost',
            title: $t('cost'),
            type: 'text',
            sort: true
          },
          {
            column: 'options',
            title: $t('Actions'),
            type: 'options',
            options: [
              { name: 'show' },
              {
                name: 'edit',
                role: $checkRole('partners_deposits_edit')
              },
              { name: 'printSalesPayment', role: true },
              { name: 'download', role: true },
              {
                name: 'delete',
                role: $checkRole('partners_deposits_delete')
              }
            ]
          }
        ]"
        :deleteText="{
          attention: $t('Attention'),
          areYouReallySureToDeleteTheItem: $t('Are you really sure to delete the item'),
          close: $t('Close'),
          confirm: $t('Confirm'),
          loading: $t('Loading')
        }"
      />
    </div>
  </div>
</template>
<script>
import indexTable from '@/elements/index/indexTable.vue'

export default {
  data() {
    return {
      path: '/partnersDeposits'
    }
  },
  components: {
    indexTable
  }
}
</script>
